import { all } from 'redux-saga/effects';
import watchNotificationsWebSocket from './ws';

export default function* notificationsSaga() {
  yield all([
    watchNotificationsWebSocket(),
  ]);
}
